import React, { useEffect, useState } from "react";
import { FaArrowRight } from "react-icons/fa";

const BlocSection = () => {

  const [consul, setConsul] = useState([]);

  const fetchEntreprendre = async () => {
    try {
      // setLoading(true);
      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}/api/v1/embassy/enternship`,
        {
          method: "GET",
          headers: { "code-ambassade": "uuidARBF0A1" },
        }
      );

      if (!response.ok) throw new Error("Erreur réseau");

      const data = await response.json();
      // console.log("🔍 Données API:", data);

      if (data?.data) {

        const formatted = data.data.map((a) => ({
          // id: a.id,
          link: a.linkRedirection,
          description: a.content,
          embassy: a.embassy,
          title: a.name,
          image: a.picture
            ? a.picture.replace(/([^:]\/)\/+/g, "$1")
            : "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcR8bikI-KUuM1IWosgqDRS5jyv2U_PPYlG6Tg&s",
          alt: a.slug,
          buttonText: a.textButton,
        }));

        setConsul(formatted);
      }
    } catch (error) {
      console.error("Erreur de chargement :", error);
    } finally {
      // setLoading(false);
    }
  };

  useEffect(() => {
    fetchEntreprendre();
  }, []);

  return (
    <div className="consuls-container" style={{ display: 'flex', flexWrap: 'wrap', gap: '20px', justifyContent: 'space-between', padding: '20px' }}>
      {consul.map((consul, index) => (
        <div className="consul-card" key={index} style={{ flex: '0 0 calc(50% - 10px)', boxSizing: 'border-box' }}>
          <img
            src={consul.image}
            alt={consul.slug}
            className=""
            style={{
              width: index === 0 ? '170px' : index === 1 ? '90px' : '80px',
              height: 'auto'
            }}
          />
          <p dangerouslySetInnerHTML={{ __html: consul.description }}></p>
          <a href={consul.link}>
            <button className="consul-btn">
              {consul.buttonText} <FaArrowRight />
            </button>
          </a>
        </div>
      ))}
    </div>
  );
}

export default BlocSection;